import { useState } from "react";

import { LuTrash } from "react-icons/lu";
import { CommunityPage } from "~/types/CommunityTypes";
import { api } from "~/utils/api";
import { Button } from "../../themed/Button";
import { Input } from "../../themed/Input";
import ThemedLink from "../../themed/ThemedLink";
import { useRouter } from "next/navigation";
import { toast } from "react-toastify";

interface MoreLinksProps {
    community: CommunityPage;
    refetch?: () => void;
}

const EditMoreLinks: React.FC<MoreLinksProps> = ({ community, refetch }) => {
    const [newLink, setNewLink] = useState<{ name?: string; url?: string }>();
    const router = useRouter();

    const updateCommunity = api.community.updateCommunity.useMutation();

    const communityLinks = community?.links.filter(
        (l) => l.type === "COMMUNITY" || l.type === "OTHER",
    );

    const handleEditMoreLinks = (idToDelete?: string) => {
        if (!community) return;
        const onSuccess = {
            onSuccess: () => {
                setNewLink(undefined);
                refetch?.();
                router.refresh();
                toast.success("Link updated successfully");
            },
        };

        if (idToDelete) {
            updateCommunity.mutateAsync(
                {
                    slug: community.slug,
                    newLink: {
                        idToDelete,
                    },
                },
                onSuccess,
            );
        }

        if (newLink && newLink.name && newLink.url) {
            updateCommunity.mutateAsync(
                {
                    slug: community.slug,
                    newLink: {
                        name: newLink.name,
                        url: newLink.url,
                        type: "OTHER",
                    },
                },
                onSuccess,
            );

            setNewLink(undefined);
        }
    };

    return (
        <div className="flex flex-col items-start gap-2">
            <>
                <div className="flex h-[58px] items-center">
                    <h6>More</h6>
                </div>
                <div className="flex gap-2 ">
                    <Input
                        placeholder="Name"
                        className="h-full"
                        value={newLink?.name ?? ""}
                        onChange={(e) =>
                            setNewLink({
                                ...newLink,
                                name: e.target.value,
                            })
                        }
                    />
                    <Input
                        placeholder="Url"
                        className="h-full"
                        value={newLink?.url ?? ""}
                        onChange={(e) =>
                            setNewLink({
                                ...newLink,
                                url: e.target.value,
                            })
                        }
                    />
                    <Button
                        className="w-max rounded"
                        onClick={() => handleEditMoreLinks()}
                    >
                        Add
                    </Button>
                </div>
            </>
            {communityLinks && communityLinks.length > 0 && (
                <div className="flex w-full flex-col gap-2">
                    {communityLinks.map((l, i) => (
                        <div
                            className="flex justify-between"
                            key={"more-links-" + i}
                        >
                            <ThemedLink
                                href={l.url}
                                variant="secondary"
                                className="h-full p-0"
                                target="_blank"
                            >
                                {l.name}
                            </ThemedLink>
                            <Button
                                className="max-w-[50px] rounded p-2"
                                variant="destructive"
                                onClick={() => handleEditMoreLinks(l.id)}
                            >
                                <LuTrash />
                            </Button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default EditMoreLinks;
